import 'react';
import ClassNames from 'classnames';
var REACT_ELEMENT_TYPE;
function _createRawReactElement(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
var namespace = 'layout-wrapper';
var LayoutWrapper = function LayoutWrapper(_ref) {
  var _ref$wrapper_element = _ref.wrapper_element,
    Component = _ref$wrapper_element === void 0 ? 'div' : _ref$wrapper_element,
    children = _ref.children,
    direction = _ref.direction,
    extraClassname = _ref.extraClassname,
    _ref$wrapperStyle = _ref.wrapperStyle,
    wrapperStyle = _ref$wrapperStyle === void 0 ? {} : _ref$wrapperStyle;
  var LayoutWrapperClasses = ClassNames(namespace, _defineProperty(_defineProperty({}, "layout-wrapper-component-".concat(direction, "-container"), !!direction), extraClassname, !!extraClassname));
  return /*#__PURE__*/_createRawReactElement(Component, {
    className: LayoutWrapperClasses,
    style: wrapperStyle
  }, void 0, children);
};
var LayoutWrapper$1 = LayoutWrapper;
export { LayoutWrapper$1 as LayoutWrapper, LayoutWrapper$1 as default };
